/**
 * Color utility functions for public chatbot client
 * Shared logic for white color detection
 */

/**
 * Check if a color string represents white
 * @param color - The color string to check (hex, rgb, rgba, or color name)
 * @returns True if the color is white, false otherwise
 */
export function isWhiteColor(color: string | undefined): boolean {
  if (!color) return false;

  const normalizedColor = color.toLowerCase().replace(/\s/g, '');
  return (
    normalizedColor === '#ffffff' ||
    normalizedColor === '#fff' ||
    normalizedColor === 'white' ||
    normalizedColor === 'rgb(255,255,255)' ||
    normalizedColor === 'rgba(255,255,255,1)'
  );
}
